import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useIntl } from "react-intl";
import Tooltip from "@material-ui/core/Tooltip";
import MicOnIcon from "@material-ui/icons/MicNoneOutlined";
import MicOffIcon from "@material-ui/icons/MicOffOutlined";
import NewWindowIcon from "@material-ui/icons/OpenInNew";
import FullScreenIcon from "@material-ui/icons/Fullscreen";
import IconButton from "@material-ui/core/IconButton";
import useHover from "../../../hooks/useHover";

const useStyles = makeStyles((theme) =>
  createStyles({
    peerActionButton: {
      margin: theme.spacing(1),
      color: "#ffffff",
      backgroundColor: "#181C1E",
      "&:hover": {
        backgroundColor: "rgba(97, 97, 97, 0.9)",
      },
    },
    micButton: {
      backgroundColor: "#F7F8FD",
      "&:hover": {
        backgroundColor: "#e1e1e1",
      },
    },
    micButtonOn: {
      color: "#181C1E",
    },
    micButtonOff: {
      color: "#F3465A",
    },
    controls: {
      position: "absolute",
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-end",
      zIndex: 21,
      opacity: 0,
      transition: "opacity 0.3s",
      touchAction: "none",
      "&.hover": {
        opacity: 1,
      },
      "&.tiny": {
        alignItems: "center",
        flexDirection: "row",
        "& button": {
          margin: 2,
          padding: 2,
        },
      },
    },
  })
);

const HoveredView = ({
  muteAudioButton = {
    visible: false,
    disabled: false,
    onClick: () => {},
    micEnabled: false,
  },
  newWindowButton = { visible: false, disabled: false, onClick: () => {} },
  fullScreenButton = { visible: false, disabled: false, onClick: () => {} },
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const [hoverRef, isHovered] = useHover();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isTiny = hoverRef.current ? hoverRef.current.clientHeight < 150 : false;
  let smallButtons = false;
  return (
    <div
      ref={hoverRef}
      className={classnames(
        classes.controls,
        isHovered ? "hover" : null,
        isTiny ? "tiny" : null
      )}
    >
      {muteAudioButton.visible && (
        <Tooltip
          title={intl.formatMessage({
            id: "device.muteAudio",
            defaultMessage: "Mute audio",
          })}
          placement={smallScreen ? "top" : "left"}
        >
          <span>
            <IconButton
              aria-label={intl.formatMessage({
                id: "device.muteAudio",
                defaultMessage: "Mute audio",
              })}
              className={classnames(
                classes.peerActionButton,
                classes.micButton,
                !muteAudioButton.micEnabled
                  ? classes.micButtonOff
                  : classes.micButtonOn
              )}
              disabled={muteAudioButton.disabled}
              onClick={muteAudioButton.onClick}
            >
              {muteAudioButton.micEnabled ? (
                <MicOnIcon fontSize={smallButtons ? "small" : "large"} />
              ) : (
                <MicOffIcon fontSize={smallButtons ? "small" : "large"} />
              )}
            </IconButton>
          </span>
        </Tooltip>
      )}
      {newWindowButton.visible && (
        <Tooltip
          title={intl.formatMessage({
            id: "label.newWindow",
            defaultMessage: "New window",
          })}
          placement={smallScreen ? "top" : "left"}
        >
          <span>
            <IconButton
              aria-label={intl.formatMessage({
                id: "label.newWindow",
                defaultMessage: "New window",
              })}
              className={classes.peerActionButton}
              disabled={newWindowButton.disabled}
              onClick={newWindowButton.onClick}
            >
              <NewWindowIcon fontSize={smallButtons ? "small" : "large"} />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {fullScreenButton.visible && (
        <Tooltip
          title={intl.formatMessage({
            id: "label.fullscreen",
            defaultMessage: "Fullscreen",
          })}
          placement={smallScreen ? "top" : "left"}
        >
          <span>
            <IconButton
              aria-label={intl.formatMessage({
                id: "label.fullscreen",
                defaultMessage: "Fullscreen",
              })}
              className={classes.peerActionButton}
              disabled={fullScreenButton.disabled}
              onClick={fullScreenButton.onClick}
            >
              <FullScreenIcon fontSize={smallButtons ? "small" : "large"} />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default HoveredView;
